<template>
  <div class="wapper">
    <el-container>
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.phone"
                      placeholder="手机"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.company"
                      placeholder="公司"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.position"
                      placeholder="职务"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.idCard"
                      placeholder="身份证"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.groupNo"
                      placeholder="团组"
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否审核">
                  <el-select placeholder="是否审核：" v-model="searchForm.verify">
                    <el-option value="-1" label="全部"></el-option>
                    <el-option value="0" label="否"></el-option>
                    <el-option value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                  <el-date-picker
                      v-model="searchForm.startDate"
                      type="datetime"
                      width="100"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                      v-model="searchForm.endDate"
                      type="datetime"
                      width="100"
                      placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="接机时间">
                  <el-date-picker
                      v-model="searchForm.startArrivalDate"
                      type="datetime"
                      width="100"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                      v-model="searchForm.endArrivalDate"
                      type="datetime"
                      width="100"
                      placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="送机时间">
                  <el-date-picker
                      v-model="searchForm.startGiveDate"
                      type="datetime"
                      width="100"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                      v-model="searchForm.endGiveDate"
                      type="datetime"
                      width="100"
                      placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="送达时间">
                  <el-date-picker
                      v-model="searchForm.startDeliverDate"
                      type="datetime"
                      width="100"
                      placeholder="开始日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                      v-model="searchForm.endDeliverDate"
                      type="datetime"
                      width="100"
                      placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="接机接站">
                  <el-select placeholder="是否接机接站：" v-model="searchForm.isReception">
                    <el-option value="-1" label="全部"></el-option>
                    <el-option value="0" label="否"></el-option>
                    <el-option value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否接到">
                  <el-select placeholder="是否接到：" v-model="searchForm.isReceived">
                    <el-option value="-1" label="全部"></el-option>
                    <el-option value="0" label="否"></el-option>
                    <el-option value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="送机送站">
                  <el-select placeholder="是否送机送站：" v-model="searchForm.isGive">
                    <el-option value="-1" label="全部"></el-option>
                    <el-option value="0" label="否"></el-option>
                    <el-option value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否送达">
                  <el-select
                      placeholder="是否送达："
                      clearable
                      v-model="searchForm.isDelivery"
                      class="el-input-position"
                  >
                    <el-option value="-1" label="全部"></el-option>
                    <el-option value="0" label="否"></el-option>
                    <el-option value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="入住酒店">
                  <el-select
                      placeholder="是否入住酒店："
                      v-model="searchForm.isCheckIn"
                      class="el-input-position"
                  >
                    <el-option value="-1" label="全部"></el-option>
                    <el-option value="0" label="否"></el-option>
                    <el-option value="1" label="是"></el-option>
                  </el-select>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit()"
                >搜索
                </el-button
                >
                <div class="uers-right">
                <span class="btn-r">
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出
                </el-button
                >
<!--                  <el-button-->
<!--                      type="primary"-->
<!--                      plain-->
<!--                      icon="el-icon-plus"-->
<!--                      @click="addSubmit"-->
<!--                  >新增</el-button>-->
                </span>
<!--                  <el-popover-->
<!--                      placement="bottom"-->
<!--                      title="批量导入"-->
<!--                      width="220"-->
<!--                      trigger="click"-->
<!--                  >-->
<!--                    <div>-->
<!--                      <el-upload-->
<!--                          class="upload-demo"-->
<!--                          :action="action"-->
<!--                          :auto-upload="false"-->
<!--                          :on-change="uploadChange"-->
<!--                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"-->
<!--                      >-->
<!--                        <el-button size="small" type="primary"-->
<!--                        >选择导入模板-->
<!--                        </el-button-->
<!--                        >-->
<!--                      </el-upload>-->
<!--                      <el-button-->
<!--                          type="success"-->
<!--                          @click="download"-->
<!--                          plain-->
<!--                          icon="el-icon-download"-->
<!--                          class="down-template"-->
<!--                      >下载模板-->
<!--                      </el-button-->
<!--                      >-->
<!--                    </div>-->
<!--                    <p class="import-text">只能选择 .xls .xlsx 文件</p>-->
<!--                    <div>-->
<!--                      <el-button type="success" @click="importData"-->
<!--                      >开始导入-->
<!--                      </el-button-->
<!--                      >-->
<!--                    </div>-->

<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        plain-->
<!--                        icon="el-icon-upload2"-->
<!--                        slot="reference"-->
<!--                    >导入-->
<!--                    </el-button-->
<!--                    >-->
<!--                  </el-popover-->
<!--                  >-->
<!--                  &nbsp;-->
                </div>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="idCard"
                  width="150"
                  label="姓名/团组"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.groupNo }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  width="150"
                  label="手机号/身份证号"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.phone }}</p>
                  <p>{{ scope.row.idCard }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="company" width="160" label="公司/职务" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.company }}</p>
                  <p>{{ scope.row.position }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="disabled"
                  width="80"
                  label="是否审核"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{
                      scope.row.verify === 1 ? "是" : "否"
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="position"
                  width="160"
                  label="抵达信息"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>
                    {{
                      '方式：' + (scope.row.arrivalMethod ? scope.row.arrivalMethod : "-") +
                      ' 位置：' + (scope.row.arrivalLocation ? scope.row.arrivalLocation : "-") +
                      ' 班次：' + (scope.row.arrivalGrades ? scope.row.arrivalGrades : "-")
                    }}</p>
                  <p>{{
                      (scope.row.arrivalDate ? scope.row.arrivalDate.split(' ')[0] + " " : "-")
                    }}{{ scope.row.arrivalTime }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="isSign"
                  width="80"
                  label="接机接站"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>接机：{{ scope.row.isReception == 1 ? "是" : "否" }}</p>
                  <p>接到：{{
                      scope.row.isReceived === 1 ? "是" : "否"
                    }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="position"
                  width="120"
                  label="接机人信息"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.receivedName }}&nbsp;{{ scope.row.receivedPhone }}</p>
                  <p>{{ scope.row.receivedCar }}&nbsp;{{ scope.row.receivedCarNo }}</p>
                  <p></p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  width="160"
                  label="酒店信息"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.isCheckIn == 1 ? "入住" : "不入住" }}&nbsp;{{ scope.row.hotel }}</p>
                  <p>{{ scope.row.roomType }}&nbsp;<span>{{ scope.row.roomNo }}</span></p>
                  <p>入住:{{ scope.row.checkInTime ? scope.row.checkInTime : "-" }}</p>
                  <P>离开:{{ scope.row.departureTime ? scope.row.departureTime : "-" }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="disabled"
                  width="80"
                  label="送机送站"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>送机：{{
                      scope.row.isGive === 1 ? "是" : "否"
                    }}</p>
                  <p>送达：{{
                      scope.row.isDelivery === 1 ? "是" : "否"
                    }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="position"
                  width="160"
                  label="送机信息"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>
                    {{
                      '方式：' + (scope.row.giveMethod ? scope.row.giveMethod : "-") +
                      ' 位置：' + (scope.row.giveLocation ? scope.row.giveLocation : "-") +
                      ' 班次：' + (scope.row.giveGrades ? scope.row.giveGrades : "-")
                    }}</p>
                  <p>{{
                      (scope.row.giveDate ? scope.row.giveDate.split(' ')[0] + " " : "-")
                    }}{{ scope.row.giveTime }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  width="180"
                  label="创建时间"
                  align="left"
              >
                <template slot-scope="scope">
                  <p>创建:{{ scope.row.createDate }}</p>
                  <p>接到:{{ scope.row.receivedTime }}</p>
                  <p>送达:{{ scope.row.deliveryTime }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button>
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditReception
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditReception>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditReception from "../../components/major/EditReception";
import DeleteDialog from "../../components/public/DeleteConfim";
import {log} from "util";
import axios from "axios";
import QRCode from 'qrcodejs2';

export default {
  data() {
    return {
      fileList: [],
      qrcode: '',
      dialogVisible: false,
      total: 0, //总条数
      currentPage: 1, //初始页
      pageSize: 10, // 每页的数据
      searchForm: {
        idCard: "",
        name: "",
        phone: "",
        code: "",
        company: "",
        groupNo: "",
        isCheckIn: "-1",
        isGive: "-1",
        verify: "-1",
        isReception: "-1",
        isReceived: "-1",
        isDelivery: "-1",
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 - 1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
        endGiveDate: null,
        startGiveDate: null,
        endDeliverDate: null,
        startDeliverDate: null,
        startArrivalDate: null,
        endArrivalDate: null,
        // startDeliverDate: new Date(
        //     new Date(new Date().toLocaleDateString()).getTime() -
        //     (new Date(new Date().toLocaleDateString()).getTime() -
        //         new Date(new Date().getFullYear().toString()))
        // ),
        // endGiveDate: new Date(
        //     new Date(new Date().toLocaleDateString()).getTime() +
        //     24 * 60 * 60 * 1000 - 1
        // ),
        // startGiveDate: new Date(
        //     new Date(new Date().toLocaleDateString()).getTime() -
        //     (new Date(new Date().toLocaleDateString()).getTime() -
        //         new Date(new Date().getFullYear().toString()))
        // ),
        // endDeliverDate: new Date(
        //     new Date(new Date().toLocaleDateString()).getTime() +
        //     24 * 60 * 60 * 1000 - 1
        // ),
        // startDeliverDate: new Date(
        //     new Date(new Date().toLocaleDateString()).getTime() -
        //     (new Date(new Date().toLocaleDateString()).getTime() -
        //         new Date(new Date().getFullYear().toString()))
        // ),
        projectId: localStorage.getItem("project_Id"),
      },
      uploadUrl: "",
      uploadDate: "",
      action: localStorage.getItem("url"),
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      receptionId: "",
    };
  },
  created() {
    this.getData();
    this.loadData();
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    loadData() {
    },
    downloadFile(data) {
      if (!data) {
        return;
      }
      const link = document.createElement("a");
      let blob = new Blob([data], {type: "application/vnd.ms-excel"});
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);

      link.setAttribute("download", "记录信息" + ".xls");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/Reception/Export`, this.searchForm)
          .then((res) => {
            loading.close();
            if (res.data.data) {
               window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出不通过");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出不通过");
          });
    },

    //  文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.$message.warning("文件已移除");
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleExceed() {
      //提示最多只能上传1个
      this.$message.warning("最多上传1个文件！");
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    upload(file, fileList) {
      this.file = event.currentTarget.files[0];
      const limitSize = 1024 * 1024 * 100;
      if (this.file.size > limitSize) {
        alert("文件大小不能超过100MB");
      }
      let formData = new FormData();
      formData.append('file', this.file);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.post("/Upload/File?eId=" + this.projectId, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.data.hasError == false) {
          this.$message.success(res.data.message)
        } else {
          this.$message.error('操作失败')
        }
        loading.close();
        this.fileList = this.fileList.slice(-1);
      }).catch((e) => {
        this.$message.error("操作失败");
        loading.close();
      });
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据
      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var formData = new FormData();
      formData.append("file", f);

      this.$axios
          .post("/Upload/File", formData, {
            headers: {"Content-Type": "multipart/form-data"},
          })
          .then((resp) => {
            this.uploadUrl = resp.data.data;
            this.uploadDate = resp.data.message;

            var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function (f) {
              var binary = "";
              var rABS = false; //是否将文件读取为二进制字符串
              var pt = this;
              var wb; //读取完成的数据
              var outdata;
              var reader = new FileReader();
              reader.onload = function (e) {
                var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for (var i = 0; i < length; i++) {
                  binary += String.fromCharCode(bytes[i]);
                }
                var XLSX = require("xlsx");
                if (rABS) {
                  wb = XLSX.read(btoa(fixdata(binary)), {
                    //手动转化
                    type: "base64",
                  });
                } else {
                  wb = XLSX.read(binary, {
                    type: "binary",
                  });
                } // outdata就是你想要的东西 excel导入的数据
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
                let ar = [];
                outdata.map((v) => {
                  let obj = {};
                  obj.name = v.姓名;
                  obj.nameEn = v.英文姓名;
                  obj.sex = v.性别称呼;
                  obj.email = v.邮箱;
                  obj.avatar = v.头像;
                  obj.company = v.公司;
                  obj.companyEn = v.公司英文;
                  obj.position = v.职务;
                  obj.idCard = v.证件号码;
                  obj.phone = v.手机号码;
                  obj.area = v.地区号码;
                  obj.countryArea = v.国家地区;
                  obj.province = v.省份;
                  obj.city = v.城市;
                  obj.address = v.地址;
                  obj.code = v.码值;
                  obj.booth = v.展位号;
                  obj.status = v.审核状态;
                  obj.telNo = v.电话号码;
                  obj.faxNo = v.传真号码;
                  obj.phoneNo = v.移动电话;
                  obj.lang = v.语言;
                  obj.openId = v.标签;
                  obj.source = v.来源;
                  obj.positionEn = v.职务英文;
                  obj.remark = v.备注;
                  obj.remark1 = v.备注1;
                  obj.remark2 = v.备注2;
                  obj.remark3 = v.备注3;
                  obj.remark4 = v.备注4;
                  obj.remark5 = v.备注5;
                  obj.addressEn = v.地址英文;
                  obj.documentType = v.证件类型;
                  obj.market = v.分论坛;
                  obj.business = v.业务范围;
                  obj.profile = v.业务类型;
                  obj.department = v.有效证件类型;
                  obj.groupNo = v.团组;
                  obj.batch = localStorage.getItem("accountId");
                  obj.groupUserId = this.groupUserId;
                  ar.push(obj);
                });
                localStorage.setItem("attr", JSON.stringify(ar));
              };
              reader.readAsArrayBuffer(f);
            };
            if (rABS) {
              reader.readAsArrayBuffer(f);
            } else {
              reader.readAsBinaryString(f);
            }
          });
    },
    importData() {
      if (this.searchForm.registerId != "") {
        this.attr = JSON.parse(localStorage.getItem("attr"));
        if (this.attr && this.attr.length > 0) {
          this.$axios
              .post("/ProjectFile/", {
                projectId: this.projectId,
                documentTypeId: this.searchForm.registerId,
                url: this.uploadUrl,
                name: "人员导入",
                code: this.uploadDate,
                remark: "人员导入" + this.uploadDate,
              })
              .then((res) => {
                if (res.data.hasError == false) {
                  const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                  });
                  let url = "/Reception/" + this.searchForm.registerId;
                  if (window.location.hostname.indexOf("gb") > -1) {
                    url = '/gb' + url;
                  }
                  this.$axios
                      .patch(url, this.attr)
                      .then((res) => {
                        if (res.data.hasError == false) {
                          loading.close();
                          this.searchSubmit();
                          localStorage.setItem("attr", null);
                          this.$message.success(res.data.message);
                        } else {
                          this.$message.error(res.data.message);
                          loading.close();
                        }
                      })
                      .catch(function () {
                        loading.close();
                      });
                }
              })
              .catch(function () {
                loading.close();
              });
        } else {
          this.$message.error("没有可上传的数据");
        }
      } else {
        this.$message.error("请选择注册通道");
      }
    },
    download() {
      var url = localStorage.getItem("url");
      if (url.lastIndexOf("/api") == url.indexOf("/api")) {
        if (window.location.hostname.indexOf("gb") > -1) {
          window.open(url.replace("/api", "/") + "/data/人员导入模板.xlsx");
        } else {
          window.open(url.replace("/api", "/") + "/data/用户模板.xlsx");
        }
      } else {
        if (window.location.hostname.indexOf("gb") > -1) {
          window.open(
              url.substring(0, url.lastIndexOf("/api")) +
              "/data/人员导入模板.xlsx"
          );
        } else {
          window.open(
              url.substring(0, url.lastIndexOf("/api")) +
              "/data/用户模板.xlsx"
          );
        }
      }

    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    addSubmit() {
      this.receptionId = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    handleDelete(index, row) {
      this.receptionId = row.receptionId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.receptionId = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/Reception/${this.receptionId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    // 获取数据
    getData() {
      this.searchForm.pageIndex = this.currentPage - 1;
      this.searchForm.pageSize = this.pageSize
      this.$axios.post("/Reception/Search", this.searchForm).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditReception,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.qr-code {
  text-align: center;
  vertical-align: center;
  margin-top: 20px;
  background-color: #fff;
}

.flex-box {
  text-align: center;
  vertical-align: center;
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin: 10px 10px 10px 10px;
}

.uers-import {
  margin-right: 30px;
  float: right;
  width: 240px;
}

.upload-excel {
  float: left;
}

.import-bnt {
  float: right;
}

.el-upload {
  height: 32px !important;
  line-height: 32px !important;
  width: 120px !important;
}

.el-upload--text {
  border: 0;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}
</style>